<template>
  <div class="loginStyle">
    <div class="loginContainer">
      <el-form
        :model="loginForm"
        ref="loginForm"
        class="loginForm"
        :rules="rules"
      >
        <!--  <img class="logoImg" src="../assets/images/logo.png" alt=""> -->
        <p class="loginTitle">后台管理系统</p>
        <el-form-item prop="username">
          <div style="display: flex; align-items: center">
            <i class="el-icon-user"></i>
            <el-input
              class="elinput"
              size="normal"
              type="text"
              v-model="loginForm.username"
              auto-complete="off"
              placeholder="请输入用户名"
              @keydown.enter.native="submitLogin('loginForm')"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <div style="display: flex; align-items: center">
            <i class="el-icon-lock"></i>
            <el-input
              show-password
              class="elinput"
              size="normal"
              type="password"
              v-model="loginForm.password"
              auto-complete="off"
              placeholder="请输入密码"
              @keydown.enter.native="submitLogin('loginForm')"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="email">
          <div style="display: flex; align-items: center">
            <i class="el-icon-message"></i>
            <el-input
              class="elinput"
              size="normal"
              v-model="loginForm.emailCode"
              auto-complete="off"
              placeholder="请输入邮箱验证码"
            >
              <el-button
                style="background-color: #67c23a; color: #fff"
                slot="append"
                type="primary"
                @click="getCode"
                :disabled="emailName != '获取邮箱验证码'"
                >{{ emailName }}</el-button
              >
            </el-input>
          </div>
        </el-form-item>
        <el-form-item align="center">
          <el-button
            size="normal"
            type="primary"
            style="width: 100%; height: 60px"
            @click="submitLogin('loginForm')"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import qs from "qs";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      vcUrl: "",
      emailName: "获取邮箱验证码",
      Interval: "",
      loginForm: {
        username: "",
        password: "",
        emailCode: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        emailCode: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    clearInterval(this.Interval);
    this.emailName = "获取邮箱验证码";
    this.Interval = null;
  },
  beforeUnmount() {
    if (this.Interval) {
      this.emailName = "获取邮箱验证码";
      clearInterval(this.Interval);
      this.Interval = null;
    }
  },
  methods: {
    getCode() {
      var _this = this;
      if (_this.Interval) {
        clearInterval(_this.Interval);
        _this.Interval = null;
      }

      if (_this.loginForm.username == "") {
        _this.$message.error("请输入用户名");
        return;
      }
      const loading = _this.$loading({
        lock: true,
        text: "发送中。。。",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      _this.$axios
        .post("/admin/login/send-verify-code", {
          username: _this.loginForm.username,
        })
        .then((res) => {
          loading.close();
          _this.$message({
            message: "发送成功！！！",
            type: "success",
          });
          var times = 60;
          _this.Interval = setInterval(() => {
            times--;
            _this.emailName = times + "秒";
            if (times <= 0) {
              clearInterval(_this.Interval);
              _this.Interval = null;
              _this.emailName = "获取邮箱验证码";
            }
          }, 1000);
        })
        .catch((error) => {
          loading.close();
        });
    },
    submitLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/admin/login/login", this.loginForm)
            .then((res) => {
              var authorization = res.data;
              authorization =
                authorization.substring(0, 1) +
                "Ai" +
                authorization.substring(1);
              authorization =
                authorization.substring(0, 10) +
                "Ti" +
                authorization.substring(10);
              authorization =
                authorization.substring(0, 18) +
                "Hi" +
                authorization.substring(18);
              authorization =
                authorization.substring(0, 26) +
                "Sy" +
                authorization.substring(26);
              authorization =
                authorization.substring(0, 38) +
                "V22" +
                authorization.substring(38);
              authorization =
                authorization.substring(0, authorization.length - 1) +
                "AGhdGAUE6Y" +
                authorization.substring(authorization.length - 1);
              this.$store.commit("SET_TOKEN", authorization);
              this.$router.push("/index").catch(() => {});
            })
            .catch((error) => {});
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.loginStyle {
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/images/login-bg.jpg");
  width: 100%;
  height: 100%;
  background-size: cover;
}
.loginContainer {
  width: 87.5%;
  height: 87%;
  background-image: url("../assets/images/login1.jpg");
}
.loginForm {
  margin-left: 900px;
  margin-top: 210px;
  width: 400px;
}
.loginTitle {
  margin: 15px auto 20px auto;
  text-align: center;
  color: #303033;
}
.logoImg {
  width: 114px;
  height: 80px;
  margin: 0 auto;
  display: block;
}
/* 利用穿透，设置input边框隐藏 */
.elinput >>> .el-input__inner {
  border: 0;
}
.elinput {
  margin-left: 20px;
}
.loginRemember {
  text-align: left;
  margin: 0px 0px 15px 0px;
}
</style>
